const cached_products = {
  namespaced: true,
  state: {
    products: [],
    interests: []
  },
  mutations: {
    add_only_new_product (state, product) {
     state.products.find( 
        el =>  
        el.type === product.type && el.id === product.id
      ) || state.products.push(product)
    },
    add_new_interest(state, interest) {
      state.interests.find(
        el => el.id === interest.id
      ) || state.interests.push(interest)
    },
    clear_products(state) {
      state.products = []
    },
    clear_interests(state) {
      state.interests = []
    }
  },
  actions: {
    add_product ({commit}, product) {
      commit('add_only_new_product', product)
    },
    add_products ({commit}, products) {
      products?.forEach( el => {
        commit('add_only_new_product', el)
      })
    },
    add_interest({commit}, interest) {
      commit('add_new_interest', interest)
    },
    clear_products({commit}) {
      commit('clear_products')
    },
    clear_interests({commit}) {
      commit('clear_interests')
    }
  },
  getters: {
    // homes.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
    // .sort(
    //   (a,b) => a.attributes['name'].localCompare(b.attributes['name'])
    // )
    brands (state) {
      return state.products.filter(
        el => el.type === 'brands'
      )
    },
    product_models (state) {
      return state.products.filter(
        el => el.type === 'product-models'
      )
    },
    product_listings (state) {
      return state.products.filter(
        el => el.type === 'product-listings'
      )
    },
    product_items (state ) {
      return state.products.filter(
        el => el.type === 'product-items'
      )
    },
    interests(state) {
      return state.interests
    },
    interest_ids(state) {
      return state.interests.map((obj) => obj.id)
    }
  }
}

export default cached_products